import React, { type PropsWithChildren, useCallback, useMemo, useState } from 'react';

import NavigationConfirmationHandlerContext, {
  type NavigationConfirmationHandlerCtx,
} from './context';
import type { NavigationConfirmationHandlers } from './types';

const NavigationConfirmationHandlerContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [handler, setHandler] = useState<NavigationConfirmationHandlers>();

  const resetHandler = useCallback(() => {
    setHandler(undefined);
  }, []);

  const value = useMemo<NavigationConfirmationHandlerCtx>(
    () => ({
      handler,
      resetHandler,
      setHandler,
    }),
    [handler, resetHandler],
  );

  return (
    <NavigationConfirmationHandlerContext.Provider value={value}>
      {children}
    </NavigationConfirmationHandlerContext.Provider>
  );
};

export default NavigationConfirmationHandlerContextProvider;
